/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeadApiModel } from '../../models/lead-api-model';

export interface Retrieve$Params {
  id: string;
}

export function retrieve(http: HttpClient, rootUrl: string, params: Retrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<LeadApiModel>> {
  const rb = new RequestBuilder(rootUrl, retrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LeadApiModel>;
    })
  );
}

retrieve.PATH = '/leads/{id}';
